/**
 * Occupancy-gauge thresholds ("feels empty below" / "feels overcrowded above") are optional at
 * every level (organization default → office → room/parking). A pair is valid when it is either
 * left unset entirely, or fully filled in with 0 <= min < max <= 100.
 *
 * Unset arrives as `null` from the API and as `undefined` from a cleared input, so both count as
 * "not set" — comparing only against `undefined` made a null pair fall through to the range check,
 * where `null >= 0` passes but `null < null` fails, and saving an untouched room/office/parking
 * was rejected with the min-must-be-lower-than-max message.
 */
const isThresholdPairValid = (min: number | null | undefined, max: number | null | undefined): boolean => {
  const hasMin = min !== undefined && min !== null;
  const hasMax = max !== undefined && max !== null;

  if (!hasMin && !hasMax) {
    return true;
  }

  if (!hasMin || !hasMax) {
    return false;
  }

  return min >= 0 && max <= 100 && min < max;
};

export default isThresholdPairValid;
